function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#879499"
    },
    d: "M265.158,323.49l-61.195,60.285c-3.883,3.825-10.454,1.074-10.454-4.376v-84.448h71.648v28.539 H265.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAEBF9"
    },
    d: "M235.911,300.786l136.584,112.481c3.503,2.885,8.819,1.106,9.878-3.308L478.943,7.59 c1.188-4.95-3.816-9.115-8.468-7.047L36.527,193.408c-4.864,2.162-4.864,9.065,0,11.227l140.02,62.231L235.911,300.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCCED5"
    },
    d: "M435.534,52.98L235.912,300.787l-32.531,81.725c-2.553,5.617-10.866,4.386-11.682-1.73 l-15.152-113.915l250.122-222.33C432.302,39.527,440.262,47.111,435.534,52.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#04A1EE"
    },
    d: "M249.822,397.121c-2.999-2.998-7.861-2.999-10.859,0.001l-67.842,67.843 c-2.999,3-2.999,7.861,0,10.86c1.499,1.499,3.465,2.248,5.429,2.248c1.965,0,3.93-0.749,5.429-2.249l67.842-67.843 C252.821,404.982,252.821,400.121,249.822,397.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#04A1EE"
    },
    d: "M137.194,312.846L69.881,380.16c-2.999,3-2.999,7.861,0,10.861c1.499,1.499,3.465,2.248,5.429,2.248 c1.965,0,3.93-0.75,5.429-2.248l67.313-67.314c2.999-3,2.999-7.861,0-10.86C145.055,309.849,140.193,309.849,137.194,312.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#04A1EE"
    },
    d: "M137.194,397.124L35.43,498.891c-2.999,3-2.999,7.861,0,10.86c1.499,1.499,3.465,2.248,5.429,2.248 c1.965,0,3.93-0.749,5.429-2.249l101.765-101.767c2.999-3,2.999-7.861,0-10.86C145.055,394.126,140.193,394.126,137.194,397.124z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.7cac91fc.svg";
export { ForwardRef as ReactComponent };